import React from 'react';
import { ActivityType, Activity } from '../../types';

interface DashboardNavProps {
  activities: Activity[];
  selectedActivity: ActivityType;
  onSelectActivity: (activity: ActivityType) => void;
 
}

const DashboardNav: React.FC<DashboardNavProps> = ({ activities, selectedActivity, onSelectActivity }) => {
  return (
    <nav 
      id="activity-sidebar" 
      className="w-64 bg-slate-800 text-slate-100 p-4 space-y-2 flex flex-col"
      aria-label="Menu attività principali"
    >
      <div className="text-2xl font-bold text-sky-400 mb-6 px-2">Attività</div>
      {activities.map((activity) => (
        <button
          key={activity.id}
          onClick={() => onSelectActivity(activity.id)}
          className={`
            flex items-center space-x-3 p-3 rounded-lg transition-all duration-200 ease-in-out
            w-full text-left
            focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-opacity-75
            ${selectedActivity === activity.id 
              ? 'bg-sky-500 text-white shadow-lg transform scale-105' 
              : 'hover:bg-slate-700 hover:text-sky-300'
            }
          `}
          aria-current={selectedActivity === activity.id ? 'page' : undefined}
        >
          <activity.icon className="h-6 w-6 flex-shrink-0" />
          <span className="font-medium">{activity.label}</span>
        </button>
      ))}
      <div className="mt-auto pt-4">
        <img src={process.env.PUBLIC_URL+'/logo512.png'} alt="Attrezzapp Logo" className="rounded-md opacity-70" />
        <p className="text-xs text-slate-400 text-center mt-2">© 2025 iMuttley</p>
      </div>
    </nav>
  );
};

export default DashboardNav;